module.exports = __webpack_public_path__ + "static/media/Protocol_21.06.2019.7ce16d65.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Protocol_21.06.2019.pdf
// module id = 124
// module chunks = 0